<template>
  <section id="pricing-plan">
    <multi-card-loader v-if="loader" />
    <div v-else>
      <b-row
        class="pricing-card"
      >
        <b-col
          cols="12"
        >
          <b-row>
            <b-col
              v-for="panel in panels"
              :key="panel.id"
              md="3"
              sm="6"
            >
              <b-card
                align="center"
              >
                <div
                  v-show="panel.id === currentPanelId"
                  class="pricing-badge text-right"
                >
                  <b-badge
                    variant="light-primary"
                    pill
                  >
                    {{ $t('Current panel') }}
                  </b-badge>
                </div>
                <!-- img -->
                <b-img
                  v-if="panel.icon"
                  :src="require('@/assets/images/pages/'+panel.icon)"
                  :class="[panel.id === currentPanelId ? 'mb-2 mt-2' : 'mb-2 mt-5']"
                  alt="basic svg img"
                  style="height: 85px"
                />
                <!--/ img -->
                <h3>{{ panel.name }}</h3>
                <!-- annual plan -->
                <div class="annual-plan">
                  <div class="plan-price mt-2">
                    <sup class="font-medium-1 font-weight-bold text-primary">تومان</sup>
                    <span class="pricing-basic-value font-weight-bolder text-primary font-large-1">{{ panel.price | numberFormat }}</span>
                    <sub class="pricing-duration text-body font-medium-1 font-weight-bold">/ماه</sub>
                  </div>
                </div>
                <!--/ annual plan -->

                <!-- plan benefit -->
                <b-list-group class="list-group-circle text-left">
                  <template v-for="(desc,key) in panel.description.toString().split('<br>')">
                    <b-list-group-item :key="key">
                      {{ desc }}
                    </b-list-group-item>
                  </template>
                </b-list-group>
                <!--/ plan benefit -->
                <!-- buttons -->
                <b-button
                  v-ripple.400="'rgba(113, 102, 240, 0.15)'"
                  block
                  class="mt-2"
                  :variant="buttonColor(panel)"
                  @click="createInvoice(panel)"
                >
                  {{ $t(buttonText(panel)) }}
                </b-button>
              <!-- buttons -->
              </b-card>
            </b-col>
          </b-row>
        </b-col>
      </b-row>
      <create-invoice-modal
        invoice-type="buy"
        :panel-id="panelId"
        :service-id="id"
      />
    </div>
    <!-- end pricing plan cards -->
  </section>
</template>

<script>
import Ripple from 'vue-ripple-directive'
import {
  BCard,
  BBadge,
  BImg,

  BButton,
  BRow,
  BCol,
  BListGroup,
  BListGroupItem,
} from 'bootstrap-vue'
import MultiCardLoader from '../../components/loaders/MultiCardLoader'
import CreateInvoiceModal from '../../components/invoices/modals/CreateInvoiceModal'

export default {
  components: {
    CreateInvoiceModal,
    MultiCardLoader,
    BCard,
    BBadge,
    BImg,
    BButton,
    BRow,
    BCol,
    BListGroup,
    BListGroupItem,

  },
  directives: {
    Ripple,
  },
  props: {
    id: {
      type: [String, Number],
      default: () => {},
    },
  },
  data() {
    return {
      loader: true,
      panelId: null,
      currentPanelId: null,
      rtl: this.$store.state.appConfig.layout.isRTL,
      panels: [],
      img: require('@/assets/images/banner/add-instance-aside.png'),
    }
  },
  computed: {

  },
  created() {
    this.getData()
  },

  methods: {
    getData() {
      this.loader = true
      this.$http
        .get('panels-list', {
          params: {
            service_id: this.id,
          },
        })
        .then(({ data }) => {
          this.loader = false
          this.panels = data.panels
          this.currentPanelId = data.panel_id
        })
        .catch(() => {
          this.loader = false
        })
    },
    createInvoice(panel) {
      this.panelId = panel.id
      const type = this.buttonText(panel)
      if (type === 'Downgrade') {
        this.showConfirmDialog({ title: 'Are you sure?', text: 'If you downgrade all the features of your current panel, it will be changed to the selection panel' }).then(() => {
          this.$http.put(`services/${panel.id}/downgrade`, {
            service_id: this.id,
          }).then(() => {
            window.location.reload()
          })
        })
      } else {
        setTimeout(() => {
          this.$bvModal.show('create-invoice-modal')
        }, 500)
      }
    },
    buttonText(panel) {
      if (panel.id === this.currentPanelId) return 'Extend'
      return panel.id > this.currentPanelId ? 'Upgrade' : 'Downgrade'
    },
    buttonColor(panel) {
      if (panel.id === this.currentPanelId) return 'info'
      return panel.id > this.currentPanelId ? 'success' : 'danger'
    },
  },
}
</script>
<style lang="scss">
@import '@core/scss/vue/pages/page-pricing.scss';
</style>
